"use strict";
/********************************************************************************
  HxActiveSetEvent.ts
 
  Copyright (c) Microsoft Corporation. All rights reserved.
 ********************************************************************************/
Object.defineProperty(exports, "__esModule", { value: true });
exports.HxActiveSetEventType = void 0;
var HxActiveSetEventType;
(function (HxActiveSetEventType) {
    HxActiveSetEventType["ObjectLoaded"] = "ObjectLoaded";
    HxActiveSetEventType["ObjectChanged"] = "ObjectChanged";
    HxActiveSetEventType["ObjectDeleted"] = "ObjectDeleted";
    HxActiveSetEventType["CollectionLoaded"] = "CollectionLoaded";
    HxActiveSetEventType["CollectionChanged"] = "CollectionChanged";
})(HxActiveSetEventType = exports.HxActiveSetEventType || (exports.HxActiveSetEventType = {}));
